import Axios from 'axios'
import { addParametersToUrl } from 'src/utils/url'

export type ShareUniversalAccess = 'universal' | 'universal_audience_restricted'

export interface IShareUniversal {
  shareUrl?: string
  access?: ShareUniversalAccess
  actions: {
    createUrl?: string
    updateAccessUrl?: string
    deactivateUrl?: string
  }
}

export const ShareUniversalAccessOptions = [
  { type: 'universal', label: 'Anyone with the link can view', icon: 'globe' },
  { type: 'universal_audience_restricted', label: 'Only people added can view', icon: 'lock' },
]

export function canAccess(shareable: IShareUniversal) {
  return !!shareable?.shareUrl || !!shareable?.actions?.createUrl
}

export async function getUniversalShareUrl(shareable: IShareUniversal, access?: ShareUniversalAccess) {
  if (!shareable.shareUrl && shareable.actions.createUrl) {
    const createUrl = access ? addParametersToUrl(shareable.actions.createUrl, { access }) : shareable.actions.createUrl

    await Axios.post<IShareUniversal>(createUrl).then((response) => {
      shareable.shareUrl = response.data.shareUrl
      shareable.access = response.data.access
      shareable.actions = response.data.actions
    })
  }

  return shareable.shareUrl
}

export async function updateUniversalShareAccess(shareable: IShareUniversal, access: ShareUniversalAccess) {
  if (shareable.actions.updateAccessUrl) {
    await Axios.put<IShareUniversal>(addParametersToUrl(shareable.actions.updateAccessUrl, { access })).then(
      (response) => {
        shareable.shareUrl = response.data.shareUrl
        shareable.access = response.data.access
        shareable.actions = response.data.actions
      }
    )
  } else {
    await getUniversalShareUrl(shareable, access)
  }
}

export async function deactivateUniversalShareUrl(shareable: IShareUniversal) {
  if (shareable.actions.deactivateUrl) {
    await Axios.put(shareable.actions.deactivateUrl).then(() => {
      shareable.shareUrl = null
      shareable.access = null
      shareable.actions.deactivateUrl = null
    })

    return true
  }

  return false
}
